import { render, staticRenderFns } from "./FileContainer.vue?vue&type=template&id=3908aba7&scoped=true&"
import script from "./FileContainer.vue?vue&type=script&lang=js&"
export * from "./FileContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3908aba7",
  null
  
)

export default component.exports